var React = require('react');

function Help (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M30 60C13.5 60 0 46.5 0 30S13.5 0 30 0s30 13.5 30 30-13.5 30-30 30zm0-55.4C16 4.6 4.6 16 4.6 30S16 55.4 30 55.4 55.4 44 55.4 30 44 4.6 30 4.6zm0 34.6a2.26 2.26 0 0 1-2.3-2.3c0-5.9 3.7-8 6.3-9.6 2.4-1.4 4-2.4 4-5.6 0-2.1-.8-3.8-2.4-5-1.3-1-3.4-1.7-5.6-1.7-3 0-8.1 1.4-8.1 6.8a2.26 2.26 0 0 1-2.3 2.3 2.26 2.26 0 0 1-2.3-2.3c0-15 25.4-15 25.4 0 0 5.9-3.7 8-6.3 9.6-2.4 1.4-4 2.4-4 5.6a2.4 2.4 0 0 1-2.4 2.2z","key":0}),React.createElement("circle",{"cx":"30","cy":"45.6","r":"1.7","key":1})]);
}

Help.defaultProps = {"baseProfile":"tiny","viewBox":"0 0 60 60","overflow":"visible"};

module.exports = Help;

Help.default = Help;
